import axios, { AxiosRequestHeaders } from 'axios';
import { apiUrl } from '../config';

export const instance = axios.create({
  baseURL: apiUrl
});

instance.interceptors.request.use(
  async (config) => {
    const token = await localStorage.getItem('accessToken');
    if (token) {
      config.headers = {
        Authorization: `Bearer ${token}`
      } as AxiosRequestHeaders
    } 
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
export default instance;